export async function fetchShowPoster(title, year) {
  const params = new URLSearchParams({ action: 'poster', title });
  if (year) params.set('year', String(year));
  try {
    const resp = await fetch(`/api/shows?${params}`);
    if (!resp.ok) return null;
    const { posterUrl } = await resp.json();
    return posterUrl ?? null;
  } catch {
    return null;
  }
}

export async function searchShows(query) {
  try {
    const resp = await fetch(`/api/shows?action=search&q=${encodeURIComponent(query)}`);
    if (!resp.ok) return [];
    return resp.json();
  } catch {
    return [];
  }
}
